import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class GenerateShortUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.MESSAGE
		this.url = '/sms/generateShortUrl'
		this.desc = '大汉三通生成短链'
	}
}

export class AnalysisShortUrlApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.MESSAGE
		this.url = '/sms/analysisShortUrl'
		this.desc = '解析大汉三通短链'
	}
}
